module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "xl-nav"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "homep"
  }, [_c('img', {
    attrs: {
      "src": require("../images/xl_banner_05.png"),
      "alt": "首页"
    }
  })]), _c('span', [_vm._v("首页")])])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../images/xl_banner_03.png"),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.xianlaigame.com/#/gamecenter"
    }
  }, [_c('div', {
    staticClass: "gamep"
  }, [_c('img', {
    attrs: {
      "src": require("../images/xl_banner_07.png"),
      "alt": "游戏中心"
    }
  })]), _c('span', [_vm._v("游戏中心")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.xianlaigame.com/#/activecenter"
    }
  }, [_c('div', {
    staticClass: "activep"
  }, [_c('img', {
    attrs: {
      "src": require("../images/xl_banner_09.png"),
      "alt": "活动中心"
    }
  })]), _c('span', [_vm._v("活动中心")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0822aa4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Nav.vue
// module id = 258
// module chunks = 1